export default class HttpStatusCode {
  public static OK = 200
  public static BAD_REQUEST = 400
  public static UNAUTHORIZED = 401
  public static NOTFOUND = 404
  public static INTERNAL_SERVER_ERROR = 500
  public static UNKNOW_ERROR = 700
  public static REQUEST_CANCEL = 800
}
